module.exports = __webpack_public_path__ + "static/media/tick.fca31e5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tick.svg
// module id = ./src/assets/icons/tick.svg
// module chunks = 0